import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import AppNavbar from "../components/common/AppNavbar";

function HoliWishesPage() {
  return (
    <>
      <AppNavbar />
      <div className="container my-5">
        {/* Header */}
        <div className="mb-4">
          <h2 className="fw-bold">
            Bharat Abroad Celebrates the Festival of Colors – Happy Holi 2026
          </h2>
          <p className="text-muted">March 3, 2026 — Global Celebration</p>
        </div>

        {/* Video Section */}
        <div className="mb-5">
          <div className="ratio ratio-16x9">
            <iframe
              src="https://www.youtube.com/embed/Nr2luCXISLM"
              title="Holi Celebration"
              allowFullScreen
            ></iframe>
          </div>
        </div>

        {/* Main Content */}
        <div className="mb-4">
          <p>
            Holi, the vibrant Festival of Colors, brings together people across
            Bharat and the global diaspora in a joyful celebration of unity,
            love, and renewal. As colors fill the air and laughter echoes in
            every corner, Holi reminds us of the triumph of good over evil and
            the beauty of togetherness.
          </p>

          <p>
            Bharat Abroad extends warm Holi wishes to communities around the
            world. May this festival inspire harmony, strengthen friendships,
            and fill your life with positivity and prosperity.
          </p>
        </div>

        {/* Significance Section */}
        <div className="mb-4">
          <h3 className="fw-bold">The Significance of Holi</h3>
          <p>
            Holi commemorates the legendary story of Prahlad and Holika,
            symbolizing the victory of devotion and righteousness over ego and
            arrogance. The lighting of the Holika bonfire signifies the burning
            away of negativity and the welcoming of a fresh beginning.
          </p>

          <p>
            The following day, known as Rangwali Holi, transforms streets and
            homes into canvases of color, celebrating equality and joy without
            barriers of age, background, or status.
          </p>
        </div>

        {/* Celebration Section */}
        <div className="mb-4">
          <h3 className="fw-bold">Holi Across the Globe</h3>
          <p>
            From local community gatherings to university campuses and cultural
            organizations abroad, Holi has become a global symbol of cultural
            pride. Indian origin communities celebrate with music, dance,
            traditional sweets, and of course, vibrant colors.
          </p>

          <p>
            Events organized by diaspora groups continue to strengthen
            cross-cultural bonds, inviting friends from all backgrounds to join
            in the celebration.
          </p>
        </div>

        {/* Wishes Card */}
        <div className="card mb-4 shadow-sm text-center">
          <div className="card-body">
            <h3 className="fw-bold text-danger">Happy Holi!</h3>
            <p className="mt-3">May your life be filled with:</p>
            <ul className="list-unstyled">
              <li>🎨 Colors of Happiness</li>
              <li>💛 Shades of Love</li>
              <li>💚 Moments of Peace</li>
              <li>💙 Success and Prosperity</li>
            </ul>
            <p className="fw-semibold mt-3">
              Wishing you and your family a safe, joyful, and colorful Holi
              celebration!
            </p>
          </div>
        </div>

        {/* Closing */}
        <div className="mb-5">
          <h3 className="fw-bold">
            Celebrating Culture, Celebrating Togetherness
          </h3>
          <p>
            At Bharat Abroad, we take pride in sharing and supporting Bharat’s
            rich cultural traditions worldwide. Holi is not just a festival — it
            is a celebration of unity, forgiveness, and new beginnings.
          </p>

          <p className="fw-semibold">
            Let the colors of Holi brighten your year ahead!
          </p>
        </div>
      </div>
    </>
  );
}

export default HoliWishesPage;
